import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { HelperService } from '../../services/helper.service';
import { LogbookService } from '../../services/logbook.service';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {finalize} from 'rxjs/operators';
import {FirebaseStorageService} from '../../services/firebase-storage.service';
import { EmployeeService } from '../../employee.service';
import {ExternalStaffService} from '../../services/external-staff.service';
import {AuthorizationService} from '../../services/authorization.service';
import { NbDialogService } from '@nebular/theme';
import { LogbooksAuthorizationComponentComponent } from '../../authorizations/logbooks-authorization-module/logbooks-authorization-component/logbooks-authorization-component.component';
import { NewEmployeeComponent } from '../../new-employee/new-employee.component';
import * as moment from 'moment';
import { ModuleExternalStaffComponent } from '../../external-staff/module-external-staff/module-external-staff.component';

interface Logbook {
  type: any;
  activity_type: string;
  date: any;
  start_time: string;
  end_time: string;
  responsable: string;
  responsable_sign: string;
  external_staff: {
    provider: '',
    responsable: '',
  };
  fields?: any;
}

@Component({
  selector: 'ngx-add-incident-logbook',
  templateUrl: './add-incident-logbook.component.html',
  styleUrls: ['./add-incident-logbook.component.scss'],
})
export class AddincientLogbookComponent implements OnInit {
  @ViewChild(SignaturePad, { static: true }) signaturePad: SignaturePad;
  loading: boolean = false;
  signaturePadOptions: Object;

  @Input() stationId: string;
  @Output() refreshLogbook: EventEmitter<any> = new EventEmitter();
  imageBase64: string = '';

  newLogbook: Logbook = {
    type: 2,
    activity_type: '',
    date: new Date(),
    start_time: moment().format('H:mm'),
    end_time: moment().format('H:mm'),
    responsable: '',
    responsable_sign: '',
    external_staff: {
      provider: '',
      responsable: '',
    },
    fields: {
      typeLogbook: 'incident',
      description: '',
      type: [],
      responsable_charge: '',
      authorization_id: '',
    },
  };

  employees = [];
  images = [];
  uploads = [];
  uploadPercent: any;
  downloadURLs = [];
  authorizations = [];
  percentage = 0;

  responsableOptions = [
    {
      name: 'Responsable de la estación de servicio',
      value: 1,
    },
    {
      name: 'Área de mantenimiento',
      value: 2,
    },
    {
      name: 'Responsable Técnico',
      value: 3,
    },
    {
      name: 'Responsable Personal de Mantenimiento',
      value: 4,
    },
    {
      name: 'Encargado de la estación de servicio',
      value: 5,
    },
  ];
  externalStaff = [];


  constructor(
    private logbookService: LogbookService,
    private employeeService: EmployeeService,
    private externalStaffService: ExternalStaffService,
    private helperService: HelperService,
    private firebaseStorageService: FirebaseStorageService,
    private authorizationService: AuthorizationService,
    private dialogService: NbDialogService,
  ) { }

  async ngOnInit() {
    this.loading = true;
    await Promise.all([
      this.getEmployees(),
      this.getAuthorizations(),
      this.getExternalStaffStation()
    ])
    this.loading = false;
    const width = document.documentElement.clientWidth * .36;
    this.signaturePadOptions = {
      'minWidth': 2,
      'backgroundColor': 'RGBA(245, 247, 249, 1.00)',
      'canvasWidth': width,
    };
  }

  clearSignature() {
    this.signaturePad.clear();
  }

  selectedType(e) {
    console.log(e)
  }

  async loadImage(event: any) {
    if (!event.target.files.length) return;
    for await (const image of event.target.files) {
      const reader = new FileReader();
      await reader.readAsDataURL(image);
      reader.onload = (e: any) => {
        image.imageBase64 = e.target.result;
        this.images.push(image);
      };
    }
  }

  async getEmployees () {
    const [err, result] = await this.employeeService.getEmployees(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista empleados]', 'error');
    this.employees = result.data;
  }


  async getAuthorizations() {
    const [err, response]: any = await this.authorizationService.index(this.stationId);
    if (err) return this.alert('Oops,', 'error', 'Intenta más tarde [Error. Lista de Autorizaciones]');
    this.authorizations = response.data;
  }

  async getExternalStaffStation() {
    const [err, response]: any = await this.externalStaffService.getExternalStaffStation(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista proveedores]', 'error');
    this.externalStaff = response.data;
  }

  validateForm() {
    this.store()
  }

  async store() {
    const validDataHasEmptyFields = Object.keys(this.newLogbook).includes('');
    const validFieldsHasEmptyFields = Object.keys(this.newLogbook.fields).includes('');
    if (validDataHasEmptyFields || validFieldsHasEmptyFields) return this.alert('Ingresa todos los datos necesiarios', 'error');
    this.loading = true;
    const [error, result]: any = await this.logbookService.store(this.stationId, this.newLogbook);
    if (error) {
      this.loading = false;
      return this.alert('Oops, intenta más tarde', 'error');
    }
    const logbookId = result.data.id;
    if (!this.images.length) {
      this.loading = false;
      this.refreshLogbook.emit(true);
      this.logbookService.exitCreateLogbook()
      return this.alert('Bitácora creada con éxito', 'success');
    }
    await this.firebaseStorageService.setPath('images/logbooks');
    this.uploads = [];
    this.downloadURLs = [];
    for await (const [index, file] of this.images.entries()){
      const filename = `${logbookId}_${index}`;
      const fileRef = await this.firebaseStorageService.referenceCloudStorage(filename);
      const task = this.firebaseStorageService.taskCloudStorage(filename, file);

      // observe percentage changes
      this.uploadPercent = task.percentageChanges();

      // get notified when the download URL is available
      task.snapshotChanges().pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe(async (url) => {
            this.downloadURLs = this.downloadURLs.concat([url]);
            if (this.images.length === this.downloadURLs.length) {
              const firstURL = this.downloadURLs[0];
              this.downloadURLs.shift();
              const [err] = await this.logbookService.updateUrlImage(logbookId, firstURL, this.downloadURLs);
              if (err) return this.alert('Oops, ocurrio un error al cargar el archivo', 'error');
              this.refreshLogbook.emit(true);
              this.logbookService.exitCreateLogbook()
              this.alert('Bitácora creada con éxito', 'success');
              this.loading = false;
            }
          });
        }),
      ).subscribe();
    }
  }

  openModal(isEdit = false) {
    this.dialogService.open(LogbooksAuthorizationComponentComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
        isEdit,
      },
    }).onClose.subscribe((modified: boolean) => modified ? this.getAuthorizations() : console.error('no modificaron nada'));
  }

  openNewEmployee() {
    this.dialogService.open(NewEmployeeComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
      },
    }).onClose.subscribe(employeeStored => employeeStored ? this.getEmployees() : null);
  }

  async delete(index: number) {
    this.images.splice(index, 1);
  }

  async validateExternalStaff() {
    this.newLogbook.external_staff = {
      provider: '',
      responsable: '',
    };
    if (this.newLogbook.responsable !== 'otro') return;
  }

  openModalNewExternalStaff(isEdit: boolean = false) {
    this.dialogService.open(ModuleExternalStaffComponent, {
      hasScroll: true,
      context: {
        externalStaff: {
          name: '',
          rfc: '',
          address: '',
          phone: '',
        },
        stationId: this.stationId,
        isEdit,
      },
    }).onClose.subscribe((modified: boolean) => modified ? this.getExternalStaffStation() : console.error('no modificaron'));
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
